/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.24.0
 */

import { ReactElement } from 'react';

import { LinkBlock } from '@/main/components/common';

import { IUserNotificationTranslation } from '../../internationalization/types';
import { INotificationsEntity } from '../types';
import { getEdmNotificationURL } from './notificationsUtils';

export const getEdmNotificationData = (
    entity: INotificationsEntity,
    translation: IUserNotificationTranslation,
    onLinkClick?: () => void,
): [string, ReactElement] => {
    const content = getEdmNotificationContent(entity, translation);

    const linkHref = getEdmNotificationURL(entity.id);

    const ItemLink = (
        <div>
            <LinkBlock withArrow url={linkHref} onClick={onLinkClick}>
                {translation.linkText.default}
            </LinkBlock>
        </div>
    );
    return [content, ItemLink];
};

export const getEdmNotificationContent = (entity: INotificationsEntity, translation: IUserNotificationTranslation) => {
    const { edmOperatorName, macroRegionName } = entity;
    const { connectedEDM, connectedFor } = translation.content.edm;
    return edmOperatorName && macroRegionName
        ? `${connectedEDM} ${edmOperatorName} ${connectedFor} ${macroRegionName}`
        : '';
};
